<!-- nav -->
<nav class="navbar navbar-expand navbar-dark bg-dark px-3" *ngIf="user">
    <div class="navbar-nav w-100">
        <a class="nav-item nav-link" routerLink="/home" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home</a>
        @if (user.role == 'admin') {
        <a class="nav-item nav-link" routerLink="/users" routerLinkActive="active">Users</a>
        <a class="nav-item nav-link" routerLink="/devices" routerLinkActive="active">Devices</a>
        <!--<a class="nav-item nav-link" routerLink="/apps" routerLinkActive="active">Apps</a>-->
        <a class="nav-item nav-link" routerLink="/actions" routerLinkActive="active">Actions</a>
        <a class="nav-item nav-link" routerLink="/tasks" routerLinkActive="active">Tasks</a>
        }
        <div class="nav-item dropdown ms-auto">
            <button class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ user.firstName }}
            </button>
              <div class="dropdown-menu">
                <a class="dropdown-item" (click)="logout()">Logout</a>
              </div>
        </div>
        <!--<div class="ms-auto nav-link" style="color:white">Loggin as: {{ user.email }}</div>-->
    </div>
</nav>

<!-- main app container -->
<div class="container">
    <alert></alert>
    <router-outlet></router-outlet>
</div>